// extracted by mini-css-extract-plugin
export default {"textlight":"Cocacola_textlight__3hvsS","cocacolared":"Cocacola_cocacolared__2Vv1y","firstpg":"Cocacola_firstpg__36--z"};